const matching = {
  title: "Matching Engine",
  description: "AI matching between entities — workers, projects, contractors, and leads",
  sourceEntity: "Source Entity",
  targetType: "Target Type",
  findMatches: "Find Matches",
  noMatches: "No matches found",
  score: "Score",
  semanticScore: "Semantic Score",
  fieldScore: "Field Score",
  recencyScore: "Recency Score",
  breakdown: "Breakdown",
  cached: "Cached",
  refresh: "Refresh",
  refreshAll: "Refresh All",
  topMatches: "Top Matches",
  loadingMatches: "Finding matches...",
  selectSource: "Select source entity",
  selectType: "Select entity type",
  matchProfile: "Match Profile",
  editProfile: "Edit Profile",
  saveProfile: "Save",
  highMatch: "High match",
  mediumMatch: "Medium match",
  lowMatch: "Low match",
  matchedOn: "Matched on",
  lastComputed: "Last computed",
  viewEntity: "View Entity",
  batchScore: "Batch Score",
  allTypes: "All types",
  matchError: "Error finding matches",
} as const;
export default matching;
